import { AlertCircle } from 'lucide-react';
import { SlideIn } from '@/components/motion';

interface ChangesRequestedBannerProps {
  reviewComments: string | null | undefined;
}

export function ChangesRequestedBanner({ reviewComments }: ChangesRequestedBannerProps) {
  if (!reviewComments) {
    return null;
  }

  return (
    <SlideIn direction="down">
      <div className="mb-6 rounded-2xl sm:rounded-3xl lg:rounded-[40px] border-[3px] border-orange-500/60 p-5 sm:p-6 lg:p-8 bg-gradient-to-br from-orange-50/80 to-amber-50/80">
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 sm:w-16 sm:h-16 bg-white rounded-full flex items-center justify-center flex-shrink-0">
            <AlertCircle className="h-6 w-6 sm:h-8 sm:w-8 text-orange-500" />
          </div>
          <div className="flex-1 min-w-0">
            <h2 className="text-xl sm:text-2xl lg:text-[32px] text-slate-900 tracking-tight mb-2">
              Changes Requested
            </h2>
            <p className="text-base sm:text-lg text-slate-700 leading-relaxed whitespace-pre-wrap">
              {reviewComments}
            </p>
          </div>
        </div>
      </div>
    </SlideIn>
  );
}
